import React from 'react';
import { GripVertical } from 'lucide-react';

const GERRY_AVATAR = "https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/4b8bf7ab25b9d80057b361f33d446357bff4abda8b91b3c16dff2988dc9e02b7.png";

export const GerryBubble = ({ open, messages, dragging, onToggle, onHover, onDragStart }) => (
  <div
    className={`group relative cursor-pointer select-none ${dragging ? 'cursor-grabbing' : ''}`}
    onClick={() => !dragging && onToggle()}
    onMouseEnter={onHover}
    data-testid="gerry-bubble"
  >
    <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-orange-500 via-amber-400 to-orange-500 opacity-60 blur-sm group-hover:opacity-100 group-hover:blur-md transition-all animate-pulse" />

    {/* Sparkle particles */}
    <div className="absolute -inset-3 pointer-events-none">
      <div className="absolute top-0 left-1/2 w-1.5 h-1.5 bg-yellow-300 rounded-full animate-sparkle-1" />
      <div className="absolute top-1/2 right-0 w-1 h-1 bg-cyan-300 rounded-full animate-sparkle-2" />
      <div className="absolute bottom-0 left-1/4 w-1.5 h-1.5 bg-orange-300 rounded-full animate-sparkle-3" />
      <div className="absolute top-1/4 left-0 w-1 h-1 bg-purple-300 rounded-full animate-sparkle-4" />
    </div>

    <div
      onMouseDown={onDragStart}
      onTouchStart={onDragStart}
      className="absolute -top-1 -left-1 w-5 h-5 rounded-full bg-gray-800 border border-gray-600 flex items-center justify-center cursor-grab opacity-0 group-hover:opacity-100 transition-opacity z-10"
    >
      <GripVertical className="w-3 h-3 text-gray-400" />
    </div>

    <div className="relative w-16 h-16 rounded-full overflow-hidden shadow-lg shadow-orange-500/30 border-2 border-orange-400/50 group-hover:scale-110 transition-transform bg-gradient-to-br from-orange-500/20 to-purple-600/20 animate-gerry-bounce">
      <img src={GERRY_AVATAR} alt="Gerry the Goat" className="w-full h-full object-cover" />
    </div>

    {!open && messages.length > 0 && (
      <div className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-cyan-400 border-2 border-gray-950 flex items-center justify-center">
        <span className="text-[8px] font-black text-black">{Math.min(messages.length, 9)}</span>
      </div>
    )}

    {!open && (
      <div className="absolute bottom-full left-0 mb-2 px-3 py-1.5 rounded-lg bg-gray-900 border border-orange-500/30 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">
        <p className="text-xs text-orange-300 font-bold">Ask Gerry!</p>
      </div>
    )}
  </div>
);
